import type { FC } from "react";
import { LandingMenuContainer, MenuItem, MenuItemContainer, StyledLink } from "./LandingPage.style";
import { useMenuProviderContext } from "../provider/MenuProvider";

const LandingPage: FC = () => {


    const menuItems = useMenuProviderContext();

    const half = Math.ceil(menuItems.length / 2)
    const firstHalfMenu = menuItems.slice(0, half);
    const secondHalfMenu = menuItems.slice(half);


    return (

        <LandingMenuContainer>
            <MenuItemContainer>
                {firstHalfMenu.map((item) => <StyledLink color="white" to={item.navEndPoint} key={item.navEndPoint}>
                    <MenuItem>{item.menuItem}</MenuItem>
                </StyledLink>)}
            </MenuItemContainer>
            <MenuItemContainer>
                {secondHalfMenu.map((item) => <StyledLink to={item.navEndPoint} key={item.navEndPoint}>
                    <MenuItem>{item.menuItem}</MenuItem>
                </StyledLink>)}
            </MenuItemContainer>
        </LandingMenuContainer>
    );
}

export default LandingPage;